module.exports = __webpack_public_path__ + "img/ele-out-50.a5b9714b.png";